export default __webpack_public_path__ + "images/K5.3607fc9.png";